import PropTypes from "prop-types";
import React from "react";

import { getCumulativeOffset, getCumulativeScrollOffsets } from "@swa-ui/browser";
import { classNames } from "@swa-ui/string";

import { PortalRoot } from "../PortalRoot";
import styles from "./PortalWrapper.module.scss";

/**
 * Wrapper to render PortalRoot and translate anchor target to be located next to passed anchor ref.
 */

export const PortalWrapper = (props) => {
  const { children, className, containerRef, isAboveOrBelow } = props;
  const root = document.getElementById("portal-root");
  let left = 0;
  let top = 0;

  if (containerRef?.current && root) {
    const offsets = getCumulativeOffset(containerRef.current, root);
    const scrollOffsets = getCumulativeScrollOffsets(containerRef.current, root);
    const rect = containerRef.current.getBoundingClientRect();

    left = offsets.left - scrollOffsets.left + (isAboveOrBelow ? rect.width / 2 : rect.width);
    top = offsets.top + (isAboveOrBelow ? rect.height : 0);
  }

  return (
    <PortalRoot className={classNames(styles.portalWrapper, className)}>
      <div style={getStyle()}>{children}</div>
    </PortalRoot>
  );

  function getStyle() {
    return {
      position: "absolute",
      transform: `translate(${left}px, ${top}px)`,
      zIndex: "2",
    };
  }
};

PortalWrapper.propTypes = {
  /** Content that will be rendered. */
  children: PropTypes.node,

  /** Additional classes for positioning the component. */
  className: PropTypes.string,
};
